<template>
  <div class="left-chart-1 border">
    <div class="cc-header flex justify-around item-center p-0">
      <dv-decoration-1
        :color="[$color.borderColor, $color.borderColor]"
        style="width: 100px; height: 20px"
      />
      <div class="text-xl font-bold">统计概览</div>
      <dv-decoration-1
        :color="[$color.borderColor, $color.borderColor]"
        style="width: 100px; height: 20px"
      />
    </div>
    <!-- <dv-scroll-board :config="config" style="width: 100%; height: 220px" /> -->
    <div class="flex justify-around pt-2">
      <div class="circle cursor-pointer pt-6" @click="jumpArchives">
        <div class="text-xl font-bold text-center">
          {{ globalData["total"] }}
        </div>
        <div class="text-xs text-center font-bold">总调查人数</div>
      </div>
      <div class="circle cursor-pointer pt-6" @click="jumpArchives">
        <div class="text-xl font-bold text-center">
          {{ globalData["peopleWithDiseasesTotal"] }}
        </div>
        <div class="text-xs text-center font-bold">患病人数</div>
      </div>
      <div class="circle cursor-pointer pt-6" @click="jumpArchives">
        <div class="text-xl font-bold text-center">
          {{ globalData["peopleWithDiseasesRate"] | formatNum }}%
        </div>
        <div class="text-xs text-center font-bold">患病率</div>
      </div>
      <!-- <dv-decoration-9 class="circle">
        <div class="">
          <div class="text-xl font-bold text-center">
            {{ globalData["总调查人数"] }}
          </div>
          <div class="text-xs text-center">总患病人数</div>
        </div>
      </dv-decoration-9>
      <dv-decoration-9 class="circle">
        <div class="">
          <div class="text-xl font-bold text-center">
            {{ globalData["总患病人数"] }}
          </div>
          <div class="text-xs text-center">患病人数</div>
        </div>
      </dv-decoration-9>
      <dv-decoration-9 class="circle">
        <div class="">
          <div class="text-xl font-bold text-center">
            {{ globalData["总疾病率"] | formatNum }}%
          </div>
          <div class="text-xs text-center">患病率</div>
        </div>
      </dv-decoration-9> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "LeftChart1",
  data() {
    return {
      config: {
        data: [
          ["行1列1", "行1列2", "行1列3"],
          ["行2列1", "行2列2", "行2列3"],
          ["行3列1", "行3列2", "行3列3"],
          ["行4列1", "行4列2", "行4列3"],
          ["行5列1", "行5列2", "行5列3"],
          ["行6列1", "行6列2", "行6列3"],
          ["行7列1", "行7列2", "行7列3"],
          ["行8列1", "行8列2", "行8列3"],
          ["行9列1", "行9列2", "行9列3"],
          ["行10列1", "行10列2", "行10列3"],
        ],
        align: ["center"],
      },
    };
  },
  filters: {
    formatNum(num) {
      if (!num) return 0;
      let sum = 0;
      sum = (num * 100).toFixed(1);
      return sum;
    },
  },
  computed: {
    ...mapGetters(["globalData", "token"]),
  },
  methods: {
    async jumpArchives() {
      let accessToken = await this.$store.dispatch("app/getToken");
      if (!accessToken) return;
      window.open(
        `${process.env.VUE_APP_ARCHIVES_DOMAIN}?accessToken=${accessToken}`
      );
    },
  },
};
</script>

<style lang="less">
.circle {
  width: 88px !important;
  height: 118px !important;
  // background-image: url("./img/property-background1.png");
  background-size: 100% 100%;
  // padding-top: 22px;
}
.left-chart-1 {
  width: 100%;
  display: flex;
  height: 164px;
  // height: 140px;
  flex-direction: column;
  margin-bottom: 10px;
  padding-top: 8px;
  background: #fff;
  .lc1-header {
    text-align: center;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    margin-bottom: 20px;
  }

  .lc1-details {
    height: 50px;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-indent: 20px;

    span {
      color: #096dd9;
      font-weight: bold;
      font-size: 35px;
      margin-left: 20px;
    }
  }

  .lc1-chart {
    flex: 1;
  }
}
</style>
